<script>
  import options from './StafetMailudsendelseList.options'
  export default options
</script>

<template>
  <article class="kb-stafet-mailudsendelse-list">
    <p v-for="mailudsendelse in mailudsendelser" :key="mailudsendelse.id" class="kb-stafet-mailudsendelse-list__link" v-on:click="(e) => openMailudsendelseOverlay(mailudsendelse.id, e)">
      <span>{{ formatDate(mailudsendelse.sentDate) }}: {{ mailudsendelse.subject }} <span v-if="mailudsendelse.isResend">({{ getLabel('resendMarkerLabel') }})</span></span>
      <div class="kb-stafet-mailudsendelse-list__link-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#3c3c3c" viewBox="0 0 17 16"><path d="m12.167 4 3.622 4-3.622 4" stroke-linejoin="round"/><path d="M11.747 8H0"/></svg>
      </div>
    </p>

    <div v-if="mailudsendelser.length == 0">
        <p>{{ getLabel('mailudsendelserEmptyLabel') }}</p>
    </div>
  </article>
</template>
